import { useMediaScreen } from 'summon-ui'
import { Box, Group } from 'summon-ui/mantine'
import { TENANT_CONFIG } from '@config'
import OnboardingSidebar from '../../components/OnboardingSidebar'
import { useOnboardingStorage } from '../../onboarding.store'
import DiscoverView from '../Discover.view'
import IntroQuestsView from '../IntroQuests.view'
import MintAvatarOnchain from '../MintAvatarOnchain.view'
import UnlockCapsuleView from './UnlockCapsule.view'

const STEPS = [
  { name: 'Register your Wallet', description: 'Connect your wallet to the portal', id: 0 },
  {
    name: 'Complete Onboarding',
    description: 'Complete the tutorial quest',
    id: 1
  },
  { name: 'Open the Capsule', description: 'Reveal what’s hidden inside', id: 2 },
  { name: 'Meet Zeek', description: 'Mint your personal Zeek', id: 3 },
  {
    name: 'Discover Quests',
    description: `Find ways to contribute to ${TENANT_CONFIG.name} nation`,
    id: 4
  }
]

export const ZkSyncOnboardingView = () => {
  const step = useOnboardingStorage((state) => state.step)
  const isMinTablet = useMediaScreen({ breakpoint: 'tablet', type: 'min' })

  return (
    <Group h='100%' w='100%' wrap='nowrap' gap='0'>
      {isMinTablet && <OnboardingSidebar steps={STEPS} />}
      <Box p={{ base: '24', md: '32' }} w='100%' h='100%' className='relative'>
        {
          {
            1: <IntroQuestsView />,
            2: <UnlockCapsuleView />,
            3: <MintAvatarOnchain />,
            4: <DiscoverView />
          }[step]
        }
      </Box>
    </Group>
  )
}
